"use client";

import { useEffect, useState } from "react";
import Script from "next/script";

interface BookingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function BookingModal({ isOpen, onClose }: BookingModalProps) {
  useEffect(() => {
    (function (C: any, A: string, L: string) {
      let p = function (a: any, ar: any) { a.q.push(ar); };
      let d = C.document;
      C.Cal = C.Cal || function () {
        let cal = C.Cal; let ar = arguments;
        if (!cal.loaded) {
          cal.ns = {}; cal.q = cal.q || [];
          d.head.appendChild(d.createElement("script")).src = A;
          cal.loaded = true;
        }
        if (ar[0] === L) {
          const api: any = function () { p(api, arguments); };
          const namespace = ar[1]; api.q = [];
          if (typeof namespace === "string") {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar); p(cal, ["initNamespace", namespace]);
          } else p(cal, ar); return;
        } p(cal, ar);
      };
    })(window, "https://app.cal.com/embed/embed.js", "init");

    const Cal = (window as any).Cal;
    Cal("init", "30min", { origin: "https://app.cal.com" });

    Cal.ns["30min"]("inline", {
      elementOrSelector: "#my-cal-inline-30min",
      config: { 
        layout: "month_view", 
        useSlotsViewOnSmallScreen: "true",
        theme: document.documentElement.classList.contains("dark") ? "dark" : "light"
      },
      calLink: "52s-solutions/30min",
    });

    const updateTheme = () => {
      Cal.ns["30min"]("ui", {
        hideEventTypeDetails: false,
        layout: "month_view",
        theme: document.documentElement.classList.contains('dark') ? "dark" : "light",
        cssVarsPerTheme: {
          light: {
            "cal-brand": "#8b5cf6",
            "radius": "20px"
          },
          dark: {
            "cal-brand": "#8b5cf6",
            "radius": "20px"
          }
        }
      });
    };

    updateTheme();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.attributeName === "class") {
          updateTheme();
        }
      }
    });

    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });

    return () => {
      observer.disconnect();
    };
  }, []);
  
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [isOpen, onClose]);

  return (
    <>
      <div
        className={`modal-overlay ${isOpen ? "show" : ""}`}
        role="dialog"
        aria-modal="true"
        onClick={(e) => {
          if (e.target === e.currentTarget) onClose();
        }}
      >
        <button
          className="modal-close text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white"
          onClick={onClose}
          aria-label="Close modal"
        >
          &times;
        </button>
        <div className="modal-content bg-white/95 dark:bg-slate-900/90 border border-slate-200 dark:border-white/10 shadow-2xl">
          <div id="my-cal-inline-30min"></div>
        </div>
      </div>
    </>
  );
}
